import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";
import {UserSettings} from "./useGetUserSettings";

const usePutUserSettings: () => UseMutationResult<
  boolean,
  Error,
  UserSettings,
  unknown
> = () =>
  useMutation<boolean, Error, UserSettings, unknown>({
    mutationFn: async (userSettings: UserSettings) => {
      const response = await api("TRENDARO_API_URL").put(`/users/me/settings`, {
        json: {...userSettings},
      });

      if (response.status === 401)
        throw new Error("Neoprávněný přístup k Trendaro API.");

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status} při odesílání dat na Trendaro server.`,
        );
      }

      return true;
    },
  });

export default usePutUserSettings;
